import React, { CSSProperties, useState } from "react"
import t from "../../helper/t"
import ModalDialog from "./ModalDialog"


const CopyableData: React.FC<{value: string}> = ({value}) => {
  const [isMessageVisible, setMessageVisible] = useState(false)
  function copyToClipboard() {
    navigator.clipboard.writeText(value)
    setMessageVisible(true)
    setTimeout(() => setMessageVisible(false), 1000)
  }
  const style: CSSProperties = {
    "textDecoration":"none",
    "borderBottom":"1px dotted #333",
    "cursor":"pointer",
  }
  return (
    <>
      <span onClick={copyToClipboard} style={style}>{value}</span>
      <div style={{display: isMessageVisible ? "block" : "none"}}>
          <ModalDialog>
            {t("kopiert!")}
          </ModalDialog>
      </div>
    </>
  )
}

export default CopyableData;